import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import { FaArrowLeft, FaDownload, FaBookOpen } from "react-icons/fa";
import CONFIG from "../config";
import "./Kitoblar.css";

function KitobBatafsil() {
    const { id } = useParams();
    const navigate = useNavigate();
    const [book, setBook] = useState(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        fetch(`${CONFIG.API_BASE_URL}/kitoblar.php?id=${id}`)
            .then(r => r.json())
            .then(res => {
                if (res.status === 'success') {
                    setBook(res.data);
                }
            })
            .catch(err => console.error("Book load error:", err))
            .finally(() => setLoading(false));
    }, [id]);

    if (loading) return <div className="kitob-loading">Yuklanmoqda...</div>;
    if (!book) return <div className="kitob-loading">Kitob topilmadi</div>;

    return (
        <div className="kitob-quti">
            <button className="batafsil-yopish" onClick={() => navigate("/kitob")}>
                <FaArrowLeft />
            </button>

            <h1 className="yangilik-header-batafsil">{book.nomi}</h1>

            <div className="kitob-batafsil-layout">
                <div className="kitob-batafsil-image">
                    <img
                        src={`/${book.rasm}`}
                        alt={book.nomi}
                        onError={(e) => {
                            e.target.onerror = null;
                            e.target.src = "https://via.placeholder.com/300x400?text=Kitob+Rasmi";
                        }}
                    />
                </div>

                <div className="yangilik-batafsil-card">
                    <div className="batafsil-section">
                        <div className="section-icon"><FaBookOpen /></div>
                        <div className="section-content">
                            <h3>Kitob haqida</h3>
                            <p>{book.izoh}</p>
                        </div>
                    </div>

                    <div className="kitob-details-grid">
                        <div className="batafsil-section">
                            <div className="section-content">
                                <h3>Muallif</h3>
                                <p>{book.muallif}</p>
                            </div>
                        </div>
                        <div className="batafsil-section">
                            <div className="section-content">
                                <h3>Bo'lim</h3>
                                <p>{book.bolim}</p>
                            </div>
                        </div>
                        <div className="batafsil-section">
                            <div className="section-content">
                                <h3>Yil</h3>
                                <p>{book.yil}</p>
                            </div>
                        </div>
                        <div className="batafsil-section">
                            <div className="section-content">
                                <h3>Hajmi</h3>
                                <p>{book.hajmi}</p>
                            </div>
                        </div>
                    </div>

                    <div style={{ textAlign: 'center', marginTop: '20px' }}>
                        <a
                            href={book.fayl}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="yangilik-btn"
                            style={{ display: 'inline-flex', alignItems: 'center', gap: '8px', textDecoration: 'none' }}
                        >
                            <FaDownload /> Kitobni yuklab olish
                        </a>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default KitobBatafsil;
